module.exports = __webpack_public_path__ + "img/arrow_right.6e0e9875.png";